export const emptyApplication = {
  id: "",
  color: "",
  displayText: "",
  heading: "",
  infoURL: "",
  userId: "",
  cidmGroupName: "",
  site: "",
  app: "",
  from: "",
  to: ""
};
